<template>
  <fn-link
    class="il-item close"
    :class="[
      {
        'il-item--bold': fontBold,
        'il-item--thin': thin,
      },
      backgroundColor ? 'il-item--bg-' + backgroundColor : '',
      fontSize ? 'il-item--font-' + fontSize : '',
    ]"
    rops.icon
    inline
    @click="$emit('delete')"
  >
    <slot />
    <fn-icon
      icon="cross"
      size="xxs"
      :color="iconColor"
    />
  </fn-link>
</template>

<script setup lang="ts">
type ItemsListItemProps = {
  iconColor?: string;
  backgroundColor?: string;
  fontBold?: boolean;
  fontSize?: string;
  thin?: boolean;
};

withDefaults(defineProps<ItemsListItemProps>(), {
  iconColor: 'grey',
  backgroundColor: undefined,
  fontSize: undefined,
});

defineEmits(['delete']);
</script>

<style lang="scss" scoped>
.il-item {
  background-color: palette(sand, light);
  border-radius: map-get($border-radiuses, 'l');
  cursor: pointer;
  display: inline-block;
  margin: math.div($space, 5) 0;
  padding: math.div($pad, 2.5) math.div($pad, 2);

  // Colors
  @each $palette, $tones in $palettes {
    @each $tone, $hex in $tones {
      @if $tone == 'base' {
        &.il-item--bg-#{$palette} {
          background-color: $hex;
        }
      } @else {
        &.il-item--bg-#{$palette}-#{$tone} {
          background-color: $hex;
        }
      }
    }
  }

  // Font sizes
  @each $name, $size in $font-sizes-paragraph {
    &.il-item--font-#{$name} {
      font-size: $size;
    }
  }

  &.il-item--bold {
    font-weight: map-get($font-weights, 'bold');
  }

  &.il-item--thin {
    margin: 0;
    padding: math.div($pad, 4) math.div($pad, 2);
  }

  &--error {
    border: 1px solid palette(red);
  }

  &:hover {
    color: inherit;
  }

  &.link.link--inline-icon {
    :deep(.icon) {
      margin: 0 0 0 0.25em;
    }
  }

  &.link.link--inline-icon:hover {
    :deep(.link-text) {
      text-decoration: none;
    }
  }

  :deep(.icon) {
    margin-left: math.div(map-get($font-sizes-paragraph, 'l'), 4);
  }
  :deep(.link-text) {
    line-height: map-get($font-line-heights, 'xs');
  }
}
</style>
